var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    { staticClass: "lite-lower-result-materials" },
    [
      _vm.productsCost.length === 0
        ? _c("div", { staticClass: "no-materials-text" }, [
            _c("img", {
              staticClass: "lite-lower-result-tooltip-img",
              attrs: {
                src: _vm.urlForStatic("/img/select_plane_tip.png"),
                alt: "tooltip-img"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lite-lower-result-tooltip-text-container" },
              [
                _c("div", { staticClass: "lite-lower-result-tooltip-text" }, [
                  _vm._v(
                    "\n                Материалы пока не добавлены.\n                "
                  ),
                  _c("span", { staticClass: "red-text" }, [
                    _vm._v("Выберите участок")
                  ]),
                  _vm._v(
                    "\n                здания и примените к нему\n                "
                  ),
                  _c("span", { staticClass: "red-text" }, [
                    _vm._v("материал из каталога")
                  ])
                ])
              ]
            )
          ])
        : _vm._l(_vm.productsCost, function(element) {
            return _c("div", { staticClass: "lite-lower-result-grid" }, [
              _c(
                "div",
                { staticClass: "flex-center lite-lower-result-grid-el" },
                [
                  _c("img", {
                    staticClass: "lite-lower-result-img",
                    attrs: {
                      src: _vm.urlForPhoto(element.src),
                      alt: element.name
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "lite-lower-result-grid-el" }, [
                _vm._v("\n            " + _vm._s(element.name) + "\n        ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center lite-lower-result-grid-el" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getName(element.type)) +
                      "\n        "
                  )
                ]
              )
            ])
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }